import React, { useState } from 'react';
import { Select } from '@rsos/components/capstone/base';
import { soundFileMapper } from '@rsos/constants';
import useIsIRP from '@rsos/utils/useIsIRP';
import { trackChangeAudioTone } from '../audioSettingsTrackings';
import { buildOption, customComponents, customValueStyle } from './helpers';
import { getFormattedSoundValue } from './helpers';

const SoundSelect = ({ isSoundOn, tone, updateAudioSettings }) => {
  const { irpVersion } = useIsIRP();

  const [sounds] = useState(soundFileMapper);
  const [value, setValue] = useState(getFormattedSoundValue(tone));
  const handleChange = option => {
    setValue(option);
    updateAudioSettings({ tone: option.value });
    trackChangeAudioTone(irpVersion);
  };

  return (
    <Select
      options={sounds.map(buildOption)}
      components={customComponents}
      styles={customValueStyle}
      placeholder="Select sound"
      onChange={handleChange}
      value={value}
      isClearable={false}
      isDisabled={!isSoundOn}
    />
  );
};

export default React.memo(SoundSelect);
